var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "20",
        "height": "20",
        "viewBox": "0 0 16 16",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M12.627 11.32V4.506a.456.456 0 00-.172-.358.668.668 0 00-.428-.149c-.333.005-.6.231-.6.507v6.812L9.03 9.33a.651.651 0 00-.426-.15.654.654 0 00-.426.15.46.46 0 00-.177.353c0 .133.064.26.177.353l3.394 2.815a.65.65 0 00.42.149.691.691 0 00.432-.13l3.395-2.814A.452.452 0 0016 9.703a.452.452 0 00-.183-.353.668.668 0 00-.426-.147.668.668 0 00-.425.147l-2.34 1.97zM.444 12h7.111c.246 0 .445.222.445.495 0 .274-.199.495-.445.495H.445c-.246 0-.445-.222-.445-.495S.199 12 .445 12H.444zm.032-4h4.762c.263 0 .476.221.476.495a.486.486 0 01-.476.495H.476A.486.486 0 010 8.495C0 8.222.213 8 .476 8zm7.08-4H.444C.199 4 0 4.222 0 4.495s.199.495.445.495h7.11c.246 0 .445-.222.445-.495S7.801 4 7.555 4h.001z",
        "fill": "var(--mainColor)",
        "fill-rule": "nonzero"
      }
    })]));
  }
};